import {UnifyBilling, UnifyBillingContract} from './index';

function mapTier(c: UnifyBillingContract.Tier): UnifyBilling.Tier {
  const {id, is_bundle, is_custom, name, subscription_fee_usd, hourly_rate, billing_period} = c;

  return {
    id,
    name,
    bundle: is_bundle,
    custom: is_custom,
    subscriptionFee: subscription_fee_usd ?? 0,
    hourlyRate: hourly_rate ?? 0,
    interval: {
      count: billing_period.count,
      dimension: billing_period.interval,
    },
  };
}

export const unifyBillingMapper = {mapUnifyTier: mapTier};
